import {SwiperElement} from "js/swiper/swiper"

export {}

const swiperElement = document.querySelector<SwiperElement>(".g-references-slider")
const referencesSections = document.querySelectorAll(".s-references-slider")

function filterSwiperItems(subjectSelect: HTMLSelectElement, levelSelect: HTMLSelectElement) {
  const selectedSubject = subjectSelect.value
  const selectedLevel = levelSelect.value

  if (!swiperElement) return

  const swiperSlides = swiperElement.querySelectorAll<HTMLSelectElement>(".swiper-slide")

  swiperSlides.forEach((slide) => {
    const tags = Array.from(slide.querySelectorAll<HTMLElement>(".i-tag__title")).map((tag) => tag.textContent?.trim())

    const matchesSubject = selectedSubject === "" || tags.includes(selectedSubject)
    const matchesLevel = selectedLevel === "" || tags.includes(selectedLevel)

    if (matchesSubject && matchesLevel) {
      slide.style.display = ""
    } else {
      slide.style.display = "none"
    }
  })

  if (swiperElement.swiper) {
    swiperElement.swiper.update()
  }
}

function initializeReferencesSection() {
  if (swiperElement && referencesSections) {
    referencesSections.forEach((referencesSection) => {
      const subjectSelect = referencesSection.querySelector<HTMLSelectElement>("select[name='subject']")
      const levelSelect = referencesSection.querySelector<HTMLSelectElement>("select[name='level']")

      if (subjectSelect && levelSelect) {
        subjectSelect.addEventListener("change", () => filterSwiperItems(subjectSelect, levelSelect))
        levelSelect.addEventListener("change", () => filterSwiperItems(subjectSelect, levelSelect))

        // Initial filtering based on default selected values
        filterSwiperItems(subjectSelect, levelSelect)
      }
    })
  }
}

document.addEventListener("swiperReferencesLoaded", initializeReferencesSection)
